import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { TaxCertificate } from './tax-certificate.interface';

export class TaxCertificateService {
   async getTaxCertificates() {
      return await http.get<Array<TaxCertificate>>('/tax-certificates', cacheFirstConfig).then((response) => response.data);
   }
}
